import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import Account from 'models/AccountModel';

const ReportItemRecord = Record({
  accountType: null,
  value: 0,
  accounts: [],
});

export default class ReportItem extends ReportItemRecord {
  static deserialize(jsonObject) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      value: (total) => parseFloat(total),
      accounts: Hydrator.fromArray(Account.deserialize),
      accountType: (accountType) => accountType?.toLowerCase(),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new ReportItem(hydrated);
  }
}
